import React, { useEffect, useRef } from 'react';
import moduleStyles from './ai-block-preview.module.scss';
import { generateAiEffectBlocksFromResult } from './utils';
/**
 * Previews the blocks generated by the AI block in Dance Party.
 */
var AiBlockPreview = function (_a) {
    var results = _a.results;
    var blockPreviewContainerRef = useRef(null);
    var workspaceRef = useRef(null);
    // Create the workspace once the container has been rendered.
    useEffect(function () {
        if (!blockPreviewContainerRef.current) {
            return;
        }
        var emptyBlockXml = Blockly.utils.xml.textToDom('<xml></xml>');
        workspaceRef.current = Blockly.BlockSpace.createReadOnlyBlockSpace(blockPreviewContainerRef.current, emptyBlockXml, {});
    }, [blockPreviewContainerRef]);
    // Build out the blocks.
    useEffect(function () {
        if (!blockPreviewContainerRef.current || !workspaceRef.current) {
            return;
        }
        var blocksSvg = generateAiEffectBlocksFromResult(workspaceRef.current, results);
        blocksSvg.forEach(function (blockSvg) {
            blockSvg.initSvg();
            blockSvg.render();
        });
        Blockly.svgResize(workspaceRef.current);
        return function () {
            var _a;
            (_a = workspaceRef.current) === null || _a === void 0 ? void 0 : _a.clear();
        };
    }, [blockPreviewContainerRef, results]);
    // Dispose of the workspace on unmount.
    useEffect(function () { return function () { var _a; return (_a = workspaceRef.current) === null || _a === void 0 ? void 0 : _a.dispose(); }; }, []);
    return (React.createElement("span", { ref: blockPreviewContainerRef, className: moduleStyles.container }));
};
export default AiBlockPreview;
